import { UserEvent } from '../UserEventsTypes';
import { menuSelectEvents, MenuSelectEvents } from './menuSelectEvents';

export interface UserEventsMap {
  menuSelectEvents: Record<MenuSelectEvents, UserEvent>;
}

export const UserEvents: UserEventsMap = {
  menuSelectEvents
};
